<template>
  <div id="app">
    <router-view name="header" />
    <router-view name="banner" />
    <router-view :key="$route.fullPath" />

    <Noticeboard
      v-if="isShowNoticeboard && routerName !== 'Login'"
      :noticeboard-list="noticeboardList"
      :noticeboard-watch-list="noticeboardWatchList"
      :get-watched-list-id="getWatchedListId"
      @click-noticeboard="clickNotice"
    />
  </div>
</template>

<script>
import dayjs from 'dayjs';
import { mapState } from 'vuex';
// import { getCommitmentByCwId } from './assets/api/commitment';
import { getAllNoticeboard, getNoticeboardWatchByCwId, createNoticeboardWatch } from './assets/api/noticeboard';
import Noticeboard from './components/Noticeboard.vue';

export default {
  name: 'app',
  components: {
    Noticeboard,
  },
  computed: {
    ...mapState('common', ['user', 'isCommitment', 'isShowNoticeboard', 'onlineData']),
    getWatchedListId() {
      const watchedListId = [];
      const allIds = this.noticeboardList.map((i) => i.id);
      this.noticeboardWatchList.forEach((i) => {
        if (allIds.includes(i.notice_board_id)) watchedListId.push(i.notice_board_id);
      });
      return watchedListId;
    },
  },
  data() {
    return {
      noticeboardList: [],
      noticeboardWatchList: [],
      routerName: this.$router.history.current.name,
    };
  },
  created() {
    document.title = '教學平台 | 接棒程式設計學院';

    // if (this.isCommitment === null && this.user.id.includes('SW')) this.getCommitment();
    if (this.routerName !== 'Login' && !this.user.id.includes('AW')) this.getNoticeboard();
    if (this.routerName !== 'Login') {
      if (this.user.id.includes('SW')) this.getOnlineDataForSW();
      else this.getOnlineData();
    }
  },
  watch: {
    $route(to, from) {
      this.routerName = to.name;

      if (!from.name) return;
      if (this.noticeboardList.length === 0) this.getNoticeboard();
      if (this.onlineData.list === null) {
        if (this.user.id.includes('SW')) this.getOnlineDataForSW();
        else this.getOnlineData();
      }
    },
  },
  methods: {
    async getOnlineData() {
      try {
        this.$store.dispatch('common/getOnlineData');
      } catch {
        //
      }
    },
    async getOnlineDataForSW() {
      try {
        this.$store.dispatch('common/getOnlineDataForSW');
      } catch {
        //
      }
    },
    // async getCommitment() {
    //   try {
    //     await getCommitmentByCwId(this.user.id);
    //     this.$store.commit('common/SET_COMMITMENT_STATUS', true);
    //   } catch {
    //     this.$store.commit('common/SET_COMMITMENT_STATUS', false);
    //   }
    // },
    async getNoticeboard() {
      try {
        const [res1, res2] = await Promise.all([
          getAllNoticeboard(),
          getNoticeboardWatchByCwId(this.user.id),
        ]);

        this.noticeboardList = res1.data.filter((i) => i.is_show).sort((a, b) => a.order - b.order);
        this.noticeboardWatchList = res2.data
          .filter((i) => dayjs(i.click_time).format('YYYY-MM-DD') === dayjs().format('YYYY-MM-DD'));
        if (this.noticeboardList.length === 0) this.showNoticeBoard = false;
      } catch {
        //
      }
    },
    async clickNotice(id) {
      const payload = {
        notice_board_id: id,
        click_time: dayjs().format('YYYY-MM-DD HH:mm:ss'),
      };
      try {
        await createNoticeboardWatch(payload);
        this.getNoticeboard();
      } catch {
        //
      }
    },
  },
};
</script>

<style lang="scss">
#app {
  font-family: Robot, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  .login,
  .banner {
    padding-top: 66px;
  }
}

html {
  box-sizing: border-box;
}

*,
*:before,
*:after {
  box-sizing: inherit;
}

@keyframes slideIn {
  0% {
    left: -300px
  }
  100% {
    left: 0;
  }
}

@keyframes slideOut {
  0% {
    left: 0;
  }
  100% {
    left: -300px
  }
}

pre {
  display: block;
  padding: 9.5px;
  margin: 0 0 10px;
  font-size: 13px;
  line-height: 1.42857143;
  color: #333;
  word-break: break-all;
  word-wrap: break-word;
  background-color: #f5f5f5;
  border: 1px solid #ccc;
  border-radius: 4px;
}

blockquote {
  border-left: 5px solid #eee;
  padding: 10px 20px;
  margin: 0 0 20px
}

input {
  &.radius {
    outline: none;
    appearance: none;
    background: transparent;
    border: none;
    width: 100%;
    border-radius: 100px;
    box-shadow: 0 5px 8px 0 rgba(155, 155, 155, 0.5);
    background-color: #fff;
  }
  &.outline {
    outline: none;
    border-radius: 100px;
    border: 1px solid #000;
    background-color: #fff;
    padding: 0 20px;
    width: 100%;

    &:disabled {
      background: rgb(216, 216, 216);
      border: none;
    }
  }
}

input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill:active {
  transition: background-color 5000s ease-in-out 0s;
  -webkit-text-fill-color: #fff !important;
}

input[type=file] {
  display: none;
}

select {
  appearance: none;
  outline: none;
  border: none;
  background: transparent;
  width: 100%;

  &.outline {
    border-radius: 100px;
    border: 2px solid #000;
    background-color: #fff;
    padding: 0 40px 0 20px;
  }
}

textarea {
  appearance: none;
  outline: none;
  border: none;
  background: transparent;
  border: 2px solid $main-purple;
  resize: none;
  width: 100%;
  border-radius: 8px;
  padding: 8px;
}

button {
  appearance: none;
  outline: none;
  border: none;
  background: transparent;
  cursor: pointer;

  &.outline {
    border-radius: 100px;
    box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.5);
    border: solid 2px #000;
    background-color: #fff;
    transition: all .3s;
    width: 100%;
    height: 100%;

    &:hover {
      background: $main-yellow;
      transition: all .3s;
    }
  }

  &.bkgray {
    border-radius: 100px;
    background-color: rgba(155, 155, 155, 0.5);
  }
}

.vue-treeselect__value-container,
.vue-treeselect__multi-value {
  width: 100%;
  vertical-align: middle;
  /* 内容不换行，可滑动查看 */
  white-space: nowrap;
  overflow: hidden;
  overflow-x: scroll;
}

.tableM {
  > div {
    display: flex;
    margin-bottom: 20px;

    &:last-child {
      margin-bottom: 0;
    }

    .left,
    .right {
      padding-bottom: 10px;

      > div {
        padding: 0 15px;
        height: 60px;
        display: flex;
        align-items: center;

        &:last-child {
          height: 32px;
        }
      }
    }

    .left {
      width: fit-content;
      background-color: $main-yellow;
      border-radius: 20px 0 0 20px;
    }

    .right {
      flex: 1;
      border: 2px solid $main-yellow;
      border-radius: 0 20px 20px 0;
    }
  }
}

.thead {
  display: flex;
  align-items: center;
  height: 60px;
  border-radius: 20px 20px 0 0;
  background-color: $main-yellow;

  > div {
    font-size: 18px;
    text-align: center;
  }
}

.tbody {
  padding: 5px 0;

  .row {
    display: flex;
    align-items: center;

    > div {
      font-size: 18px;
      border-right: 1px solid #979797;
      text-align: center;
      padding: 12px 0;
      height: 56px;

      display: flex;
      align-items: center;
      justify-content: center;

      &:last-child {
        border: none;
      }
    }
  }
}

svg {
  cursor: pointer;
}

.selectDiv {
  position: relative;

  select {
    height: 36px;
    border: 1px solid #000;
    cursor: pointer;
  }

  svg {
    position: absolute;
    pointer-events: none;
    right: 20px;
    top: 10px;
  }
}

.selectDeco {
  position: relative;

  .options {
    position: absolute;
    bottom: 42px;

    > div {
      width: 120px;
      margin-top: 5px;
      border-radius: 100px;
      padding: 4px 10px;
      border: solid 3px $main-purple;
      background: #fff;
      color: $main-purple;
      text-align: center;
      font-weight: 500;

      &.active {
        background: $main-purple;
        color: #fff;
      }

      &:hover {
        background: $main-purple;
        color: #fff;
        cursor: pointer;
      }
    }
  }

  button {
    display: flex;
    align-items: center;
    width: fit-content;
    padding: 4px 15px;
    height: 36px;
    border-radius: 100px;
    border: solid 3px $main-purple;
    background-color: $main-purple;
    color: #fff;

    .arrow {
      margin-right: 10px;
      width: 0;
      height: 0;
      border-style: solid;

      &.up {
        border-width: 0 7px 13px 7px;
        border-color: transparent transparent #fff transparent;
      }

      &.down {
        border-width: 13px 7px 0 7px;
        border-color: #fff transparent transparent transparent;
      }
    }

    img {
      width: 18px;
      height: auto;
      margin-right: 10px;
    }
  }
}

.action-error {
  background-color: #d04e4e !important;
  padding: 6px 20px !important;
  font-weight: 500 !important;

  svg {
    margin-right: 10px;
  }
}

.action-success {
  background-color: #3bb59f !important;
  padding: 6px 20px !important;
  font-weight: 500 !important;

  svg {
    margin-right: 10px;
  }
}
</style>
